import {BaseMutationOptions, BaseUseMutationResult, useBaseMutation} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {PAYMENT_FLOWS_QUERY_KEY} from "../queryKeys";

type UpdatePaymentFlowsPriorityVariables = {payment_flow_ids: number[]};

const updatePaymentFlowsPriority = async (data: UpdatePaymentFlowsPriorityVariables): Promise<void> => {
  await axiosReachInstance.put("/payment_flows/update-priority", data);
};

export const useUpdatePaymentFlowsPriority = (
  options?: BaseMutationOptions<void, UpdatePaymentFlowsPriorityVariables>
): BaseUseMutationResult<void, UpdatePaymentFlowsPriorityVariables> => {
  return useBaseMutation<void, UpdatePaymentFlowsPriorityVariables>(updatePaymentFlowsPriority, {
    ...options,
    prefixKeysToReset: () => [[PAYMENT_FLOWS_QUERY_KEY]],
  });
};
